<template>
  <main>
    <menus/>
    <section class="coupon">
      <h3>可领取优惠券</h3>
      <ul>
        <li v-for="(v, i) in list" :key="v.id">
          <figure>
            <p class="price">
              <span>{{v.amount}}</span>
              <span>满{{v.min_consumption}}可用</span>
            </p>
            <p class="info">
              <span class="title">{{v.title}}</span>
              <span class="desc">有效期至：{{v.use_edate}}</span>
            </p>
          </figure>
          <button v-if="v.type_id === 0" :class="{get: v.is_received}" @click="getCoupon(v, i)">{{ v.is_received ? '已领取' : '立即领取' }}</button>
          <router-link tag="button" class="go" :to="{name: 'coupon_info', query: {id: v.id}}" v-else>前往查看</router-link>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import menus from '@components/menu';
export default {
  components: {
    menus
  },
  data () {
    return {
      list: []
    }
  },
  async created () {
    const { data } = await this.$axios.get('/coupon/onlineQuery');
    this.list = data;
  },
  methods: {
    async getCoupon (v, i) {
      if (v.is_received) { this.$message({ message: '已领取，请勿重复领取！', type: 'info' }); return; }
      const res = await this.$axios.get(`coupon/collection/${v.id}`);
      const state = 'success' in res;
      this.$message({ message: res.success || res.error, type: state ? 'success' : 'warn' });
      if ( state ) {
        const list = [...this.list];
        list[i].is_received = 1;
        this.list = list;
      }
    }
  }
}
</script>

<style scoped src="./get.css"></style>